import type { CSSProperties } from "react";
import { cn } from "@/lib/utils";

// Two-tone spinning ring; `size` is the outer diameter in px.
export function Loader({ size = 24, className }: { size?: number; className?: string }) {
    return (
        <span
            role="status"
            aria-label="Loading"
            className={cn("ring-loader", className)}
            style={{ "--size": `${size / 48}px` } as CSSProperties}
        />
    );
}
